<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body" style="max-width: 1050px">
            <dx-form [formData]="filter" [colCount]="3" (onEditorEnterKey)="getData()">
                    <dxi-item
                        dataField="dealerId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Dealer' }"
                        [editorOptions]="{ items: dealers, valueExpr: 'id', displayExpr: 'companyName' }"
                    ></dxi-item>
                    <dxi-item dataField="startDate" editorType="dxDateBox" [label]="{ text: 'Created From' }"></dxi-item>
                    <dxi-item dataField="endDate" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
            </dx-form>
            <div class="btn-toolbar mt-3 justify-content-end align-items-center">
                <button type="button" (click)="getData()" class="btn btn-primary">Search</button>
                <button type="button" (click)="clear()" class="btn btn-light ms-2">Clear</button>
            </div>
        </div>
    </div>
    <div class="m-1 grid-fill" *ngIf="orderLineDetails">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [dataSource]="orderLineDetails"
            [columnAutoWidth]="false"
            [showBorders]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="createDate" caption="Created" dataType="date" width="100" [sortIndex]="0" [sortOrder]="'desc'"></dxi-column>
            <dxi-column dataField="salesOrder" width="80"  cellTemplate="soTemplate"></dxi-column>
            <dxi-column dataField="companyName" width="200"></dxi-column>
            <dxi-column dataField="partNumber" width="300"></dxi-column>
            <dxi-column dataField="description" width="300"></dxi-column>
            <dxi-column dataField="dealerPrice" [format]="{ type: 'currency', precision: 2 }" width="125"></dxi-column>
            <dxi-column dataField="totalDealerPrice" [format]="{ type: 'currency', precision: 2 }" width="125"></dxi-column>
            <dxi-column dataField="cost" [format]="{ type: 'currency', precision: 2 }" width="125"></dxi-column>
            <dxi-column dataField="totalCost" [format]="{ type: 'currency', precision: 2 }" width="125"></dxi-column>
            <dxi-column dataField="quantity" width="80"></dxi-column>
            <dxi-column dataField="total" [format]="{ type: 'currency', precision: 2 }" width="125"></dxi-column>
            <dxi-column></dxi-column>
            <dxo-summary>
                <dxi-total-item column="totalDealerPrice" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                <dxi-total-item column="totalCost" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                <dxi-total-item column="total" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
            </dxo-summary>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="report-warranties-grid"></dxo-state-storing>

            <div *dxTemplate="let cell of 'soTemplate'">
                <a [routerLink]="[]" (click)="open(cell.data.salesOrderId)">{{ cell.value || '(blank)' }}</a>
            </div>

            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="orderLineDetails" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
